export enum UserRole {
  RECIPIENT = "recipient",
}
